module.exports = __webpack_public_path__ + "22ee204ba1fd3e1cb7711b534894806a.png";